import { DataBean } from "../DataBean";

export class TransportGuideState extends DataBean {




    public async getTransportGuideStateConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTransportGuideStateConstants_Number", [args]);
    }

}